<template>
  <viewOrComment type="view" />
</template>
<script lang="ts" setup>
import viewOrComment from './components/viewOrComment.vue'
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuSupervisorAccompanyingVisitDetail'
}
</script>
